<template>
    <div id="category-list-area" class="content-area">
        <div id="category-title-area">
            <div id="category-title-text">
                カテゴリ
            </div>
        </div>
        <div id="parent-category-names-area">
            <div v-for="parent_category in filterParentCategories()">
                <router-link
                    class="parent-category-name-area link"
                    v-bind:to="getLinkParamsToFilteredArticlesByCategory(parent_category.id)"
                >
                    <div class="parent-category-name-text">
                        {{parent_category.name}}
                    </div>
                    <div
                        v-if="filterCategoriesByParentCategoryId(parent_category.id).length <= 1"
                        class="parent-category-name-count"
                    >
                        {{parent_category.count}}
                    </div>
                </router-link>
                <div v-for="category in filterCategoriesByParentCategoryId(parent_category.id)">
                    <router-link
                        class="category-name-area link"
                        v-bind:to="getLinkParamsToFilteredArticlesByCategory(category.id)"
                    >
                        <div class="category-name-text">
                            {{category.name}}
                        </div>
                        <div class="category-name-count">
                            {{category.count}}
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
    <div id="yearmonth-list-area" class="content-area">
        <div id="yearmonth-title-area">
            <div id="yearmonth-title-text">
                月別アーカイブ
            </div>
        </div>
        <div id="yearmonth-names-area">
            <router-link
                v-for="yearmonth in yearmonths"
                v-bind:to="getLinkParamsToFilteredArticlesByYearMonth(yearmonth.year, yearmonth.month)"
            >
                <div class="yearmonth-name-area link">
                    <div class="yearmonth-name-text">
                        {{yearmonth.year}}/{{yearmonth.month}}
                    </div>
                    <div class="yearmonth-name-count">
                        {{yearmonth.count}}
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    import router from '@/router/index.js';

    export default {
        name: 'BlogSideMenuComponent',
        props: {
            categories: Array,
            yearmonths: Array
        },
        setup(props) {
            //-----------------------------------------
            // メソッド（APIコールなし・テンプレート内使用あり）
            //-----------------------------------------
            function getLinkParamsToFilteredArticlesByCategory(category_id) {
                const query_params = {
                    category_id: category_id,
                };
                return {name: "blog", query: query_params};
            }

            function getLinkParamsToFilteredArticlesByYearMonth(year, month) {
                const query_params = {
                    year: year,
                    month: month
                };
                return {name: "blog", query: query_params};
            }

            function filterParentCategories() {
                return props.categories.filter(category => category.parent_category_id === null);
            }

            function filterCategoriesByParentCategoryId(parent_category_id) {
                return props.categories.filter(category => category.parent_category_id === parent_category_id);
            }

            // -----------------------------------------
            // テンプレートへの返り値
            // -----------------------------------------
            return {
                getLinkParamsToFilteredArticlesByCategory,
                getLinkParamsToFilteredArticlesByYearMonth,
                filterParentCategories, filterCategoriesByParentCategoryId
            };
        }
    }
</script>

<style scoped lang="scss">
    @import '@/scss/components/blog/sideMenu.scss';
</style>
